export const SettingSkeleton = () => {
  const skeletonItems = Array.from({ length: 2 }, (_, index) => index);
  return (
    <div className="flex flex-col gap-6 md:w-[740px] mx-auto px-6 md:px-0">
      <div className="flex gap-2 items-center">
        <div className="w-[44px] h-[44px] rounded-full bg-background_white_overlay5"></div>
        <div className="w-[139px] h-6 rounded-[4px] bg-background_white_overlay5"></div>
      </div>
      <div className="flex flex-col gap-6">
        {skeletonItems.map((_, index) => {
          return (
            <div
              key={index}
              className="bg-background_white_overlay5 flex rounded-[12px] justify-between p-6"
            >
              <div>
                <div className="bg-background_white_overlay5 w-[134px] h-[28px] rounded-[4px]"></div>
                <div className="bg-background_white_overlay5 w-full h-4 rounded-[4px] mt-2"></div>
              </div>
              <div className="bg-background_white_overlay5 w-[80px] h-9 rounded-lg"></div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
